import * as React from "react"

import { cn } from "@/lib/utils"

type CalculatorCardProps = React.HTMLAttributes<HTMLElement> & {
  title: string
  description?: string
}

export function CalculatorCard({
  title,
  description,
  className,
  children,
  ...props
}: CalculatorCardProps) {
  return (
    <section
      className={cn(
        "rounded-[2rem] border border-neutral-200 bg-white p-6 shadow-sm sm:p-8",
        className
      )}
      {...props}
    >
      <div className="mb-6">
        <h2 className="text-2xl font-semibold text-neutral-950">{title}</h2>

        {description ? (
          <p className="mt-3 text-sm leading-7 text-neutral-600 sm:text-base">
            {description}
          </p>
        ) : null}
      </div>

      {children}
    </section>
  )
}